import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular";

export const SearchInputWrapper = styled.div`
  display: block;
  position: relative;
`;

export const SearchInputIcon = styled(Search)(item => item.styled);
